import React from 'react'

import { ExternalNavbarProps, NavigationBar } from '../NavigationBar'
import {
  ContentContainer,
  ImageContainer,
  FooterContainer,
  FooterTextContainer,
  Page,
} from './styled-components'

interface Props {
  image: React.ReactNode
  children?: React.ReactNode
  navigationBar?: ExternalNavbarProps
  footer?: React.ReactNode
}

export const ImageLayout = (props: Props) => (
  <div>
    <NavigationBar {...props.navigationBar} pageName={null} eventObjectName={null} />
    <Page
      content={
        <>
          <ContentContainer>
            <ImageContainer className={'christine'}>{props.image}</ImageContainer>
            {props.children}
          </ContentContainer>
          {props.footer && (
            <FooterContainer>
              <FooterTextContainer>{props.footer}</FooterTextContainer>
            </FooterContainer>
          )}
        </>
      }
    />
  </div>
)
